import { render, staticRenderFns } from "./categorie.vue?vue&type=template&id=7d6e2658"
import script from "./categorie.vue?vue&type=script&lang=js"
export * from "./categorie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports